<template>
  <div class="col border border-3">
    Le pouvoir de
    <span>
      {{ getPersonName({ personId: event.building_owner_id }) }} ({{
        getUsedMandateTantiemesChargeGenerale(event.mandate_id)
      }})
    </span>
    est non représenté.
    <appPresenceChanges :event="event" />
  </div>
</template>

<script>
import appPresenceChanges from "./snippets/presenceChanges.vue";

export default {
  components: {
    appPresenceChanges,
  },
  props: ["event"],
};
</script>
